module.exports = __webpack_public_path__ + "static/media/proj20_img13.e113660c.jpg";